
const getters = {
  getQualitySummary: state => state.qualitySummary
};

const mutations = {
  SET_QUALITY_SUMMARY(state, payload) {
    state.qualitySummary = payload.qualitySummary;
  }

};

const state = {
  qualitySummary: []
};

export default {
  getters,
  mutations,
  state
};

